module.exports = __webpack_public_path__ + "img/img-playtech-live.381b84fa.png";